import { rgba } from 'polished'
import styled from 'styled-components'

export const ScannerInputWrapper = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
`

export const ScannerIcon = styled.svg`
  position: absolute;
  left: 20px;
  top: 50%;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  fill: none;
  stroke: ${({ theme }) => theme.colors.muted};
  stroke-width: 1.6;
  stroke-linecap: round;
  pointer-events: none;
`

export const ScannerInputField = styled.input`
  width: 100%;
  height: 100%;
  min-height: 64px;
  padding: 0 20px 0 60px;
  font-size: 1.25rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.colors.global};
  border: 1px solid var(--color-line);
  border-radius: var(--radius-control);
  outline: none;
  font-family: inherit;
  background: #ffffff;
  transition: border-color 0.12s, box-shadow 0.12s;
  caret-color: ${({ theme }) => theme.colors.primary};

  &::placeholder {
    color: ${({ theme }) => theme.colors.muted};
    font-weight: 400;
    letter-spacing: 0;
  }

  &:not(:placeholder-shown) {
    border-color: ${({ theme }) => theme.colors.primary};
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => rgba(theme.colors.primary, 0.15)};
  }
`
